import { Route, Outlet } from 'react-router';
import { importOrReload } from '@/utils/route.utils';

export const memberRoutes = (
  <Route
    path="member"
    lazy={importOrReload(() => import('@/pages/member/layout'))}
  >
    <Route
      index
      path="dashboard?"
      lazy={importOrReload(() => import('@/pages/member/page'))}
    />
    <Route
      path="exam"
      lazy={importOrReload(() => import('@/pages/member/exam/layout'))}
    >
      <Route
        path="list?"
        index
        lazy={importOrReload(() => import('@/pages/member/exam/page'))}
      />
      <Route
        path="book"
        lazy={importOrReload(() => import('@/pages/member/exam/book/page'))}
      />
      <Route
        path=":examId"
        lazy={importOrReload(
          () => import('@/pages/member/exam/[examId]/layout')
        )}
      >
        <Route
          path="detail?"
          index
          lazy={importOrReload(
            () => import('@/pages/member/exam/[examId]/page')
          )}
        />
        <Route
          path="reschedule"
          lazy={importOrReload(
            () => import('@/pages/member/exam/[examId]/reschedule/page')
          )}
        />
      </Route>
    </Route>
    <Route
      path="notifications"
      lazy={importOrReload(() => import('@/pages/member/notifications/page'))}
    >
      <Route
        path="health-history"
        Component={() => {
          return <Outlet />;
        }}
      >
        <Route
          index
          path="form?"
          lazy={importOrReload(
            () => import('@/pages/member/notifications/health-history-form')
          )}
        />

        <Route
          path=":healthHistoryId"
          lazy={importOrReload(
            () => import('@/pages/member/notifications/health-history-viewer')
          )}
        />
      </Route>
    </Route>
    <Route
      path="settings"
      lazy={importOrReload(
        () => import('@/pages/member/settings/SettingsPage')
      )}
    >
      <Route
        path="advocate"
        lazy={importOrReload(
          () => import('@/pages/member/settings/advocate/AdvocatePage')
        )}
      />
    </Route>
    <Route
      path="menu"
      lazy={importOrReload(() => import('@/pages/member/navigation/page'))}
    />
    <Route
      path="already-exists-appointment"
      lazy={importOrReload(
        () => import('@/pages/member/already-exists-appointment/page')
      )}
    />
    <Route
      path="appointment-confirmed/:appointmentId"
      lazy={importOrReload(
        () => import('@/pages/member/appointment-confirmed/page')
      )}
    />

    <Route path="*" lazy={importOrReload(() => import('@/pages/not-found'))} />
  </Route>
);
